<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <!-- content-header component -->
    <app-content-header [contentHeader]="contentHeader"></app-content-header>

    <!-- Basic Alerts start -->
    <section id="sample-page">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body pb-1">
              <div class="card-datatable text-nowrap">
                <div
                  class="d-flex mb-3"
                  style="align-items: center; justify-content: space-between"
                >
                  <div class="input-group input-group-merge w-auto">
                    <input
                      type="text"
                      id="first-name-icon"
                      class="form-control"
                      name="fname-icon"
                      placeholder="ابحث فى التسجيلات "
                      (keyup)="updateFilter($event)"
                    />
                    <span class="input-group-text">
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="10"
                          cy="10.5867"
                          r="7"
                          stroke="#3F8260"
                          stroke-opacity="0.9"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M21 21.5867L15 15.5867"
                          stroke="#3F8260"
                          stroke-opacity="0.9"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                  <div class="d-flex">
                    <select
                      id="per-page"
                      class="form-control pl-3 pr-0"
                      (change)="onLimitChange($event.target.value)"
                    >
                      <option
                        *ngFor="let option of pageLimitOptions"
                        [value]="option.value"
                        [selected]="option.value == currentPageLimit"
                      >
                        {{ option.value }}
                      </option>
                    </select>
                    <!-- <button class="btn btn-outline-primary waves-effect py-0 ml-2" type="button" (click)="modalOpenDefault(modalDefault)" rippleEffect>
                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.66602 11.9199V13.2533C2.66602 13.9896 3.26297 14.5866 3.99935 14.5866H11.9993C12.7357 14.5866 13.3327 13.9896 13.3327 13.2533V11.9199" stroke="#3F8260" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M4.66602 6.58675L7.99935 3.25342L11.3327 6.58675" stroke="#3F8260" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M7.99935 3.25342V11.2534" stroke="#3F8260" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>                                    
                                <span class="pl-1">استخراج</span>
                            </button> -->
                    <!-- <button
                      class="btn btn-primary waves-effect py-0 ml-2"
                      type="button"
                      rippleEffect
                    >
                      + <span class="pl-1">فئة جديدة </span>
                    </button> -->
                    <button
                      type="button"
                      class="btn btn-danger"
                              (click)="
                                downloadFile('excel');
                              "
                      rippleEffect
                    >
                      Excel
                    </button>
                    <div class="modal-size-default d-inline-block">
                      <ng-template #modalDefault let-modal>
                        <div class="modal-header">
                          <h5 class="modal-title" id="myModalLabel160"></h5>
                          <button
                            type="button"
                            class="close"
                            (click)="modal.dismiss('Cross click')"
                            aria-label="Close"
                           title="إغلاق">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div
                          class="modal-body text-center"
                          tabindex="0"
                          ngbAutofocus
                        >
                          <h4>استخراج ملف</h4>
                          <p class="pt-1">
                            اضغط على احدى الصيغ الاتية لبدء التحميل
                          </p>
                          <div
                            class="d-flex mt-2"
                            style="justify-content: center"
                          >
                            <button
                              class="btn btn-outline-primary waves-effect"
                              rippleEffect
                              (click)="
                                downloadFile('excel');
                                modal.close('Accept click')
                              "
                            >
                              <p class="mb-50">
                                <svg
                                  width="25"
                                  height="24"
                                  viewBox="0 0 25 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clip-path="url(#clip0_5021_101257)">
                                    <path
                                      d="M15.602 13.64L13.632 16L15.602 18.36C15.952 18.78 15.902 19.41 15.472 19.77C15.282 19.93 15.062 20 14.832 20C14.542 20 14.262 19.88 14.062 19.64L12.332 17.56L10.602 19.64C10.402 19.88 10.122 20 9.83203 20C9.60203 20 9.38203 19.92 9.19203 19.77C8.77203 19.42 8.71203 18.79 9.06203 18.36L11.032 16L9.06203 13.64C8.71203 13.22 8.76203 12.59 9.19203 12.23C9.62203 11.88 10.242 11.93 10.602 12.36L12.332 14.44L14.062 12.36C14.412 11.94 15.042 11.88 15.472 12.23C15.892 12.58 15.952 13.21 15.602 13.64ZM22.332 10.49V19C22.332 21.76 20.092 24 17.332 24H7.33203C4.57203 24 2.33203 21.76 2.33203 19V5C2.33203 2.24 4.57203 0 7.33203 0H11.842C13.712 0 15.472 0.73 16.792 2.05L20.272 5.54C21.592 6.86 22.322 8.62 22.322 10.49H22.332ZM15.382 3.46C15.062 3.14 14.712 2.87 14.332 2.65V7C14.332 7.55 14.782 8 15.332 8H19.672C19.452 7.62 19.182 7.27 18.862 6.95L15.382 3.46ZM20.332 10.48C20.332 10.32 20.332 10.15 20.312 9.99H15.332C13.682 9.99 12.332 8.64 12.332 6.99V2.02C12.172 2 12.012 2 11.842 2H7.33203C5.68203 2 4.33203 3.35 4.33203 5V19C4.33203 20.65 5.68203 22 7.33203 22H17.332C18.982 22 20.332 20.65 20.332 19V10.49V10.48Z"
                                      fill="#3F8260"
                                      fill-opacity="0.9"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_5021_101257">
                                      <rect
                                        width="24"
                                        height="24"
                                        fill="white"
                                        transform="translate(0.332031)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </p>
                              <p class="mb-1 file-name">Excel</p>
                              <p class="mb-50 download">اضغط للتحميل</p>
                            </button>
                          </div>
                          <p class="note mt-2 mb-4">
                            ملحوظة : البيانات المستخرجة ستتطابق مع التصفية
                            الحالية
                          </p>
                        </div>
                      </ng-template>
                      <!-- / Modal -->
                    </div>
                  </div>
                </div>

                <!-- ngx-datatable-custom-checkbox -->
                <div class="row">
                  <div class="col-12">
                    <ngx-datatable
                      #table
                      id="ngxTable"
                      class="material bootstrap core-bootstrap"
                      [rows]="rows"
                      [columnMode]="'force'"
                      [headerHeight]="40"
                      [footerHeight]="50"
                      [limit]="10"
                      [rowHeight]="'auto'"
                      [selected]="chkBoxSelected"
                      (select)="customChkboxOnSelect($event)"
                      [scrollbarH]="true"
                      [selectAllRowsOnPage]="true"
                    >
                      <ngx-datatable-column
                        name="#"
                        prop="#"
                      ></ngx-datatable-column>
                      <ngx-datatable-column
                        name="اسم المشرف بالانجليية"
                        prop="OrganizerNameEn"
                      ></ngx-datatable-column>
                      <ngx-datatable-column
                        name="اسم المشرف بالعربيه"
                        prop="OrganizerNameAr"
                      ></ngx-datatable-column>
                      <ngx-datatable-column
                        name="اسم الفعاليه بالانجليزيه"
                        prop="EventNameEn"
                      ></ngx-datatable-column>
                      <ngx-datatable-column
                        name="اسم الفعاليه بالعربيه"
                        prop="EventNameAr"
                      ></ngx-datatable-column>
                      <ngx-datatable-column
                        name="تاريخ بدايه الفعاليه"
                        prop="EventScheduleStartTime"
                      ></ngx-datatable-column>
                      <ngx-datatable-column
                        name="تاريخ نهايه الفعاليه"
                        prop="EventScheduleEndTime"
                      ></ngx-datatable-column>
                      <ngx-datatable-column
                        name="تاريخ تسجيل الدخول"
                        prop="CheckInAt"
                      ></ngx-datatable-column>
                      <ngx-datatable-column
                        name="تاريخ تسجيل الخروج"
                        prop="CheckOutAt"
                      ></ngx-datatable-column>
                    </ngx-datatable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Basic Alerts end -->
  </div>
</div>
